import {SET_PENDING_TRANSACTIONS} from '../../types';
import { sendTx, createClient } from '../../helpers/bc';
import {getWallet} from '../../helpers/wallet';

import {
  createUnlockTakerTx
} from 'bc-sdk/dist/transaction'


export function unlockCollateral({ password, txHash, txOutputIndex }, done){
  return async function(dispatch,getState) {
    try {
      let { privateKey: bcPrivateKeyHex, address: bcAddress } = getWallet(getState, 'nrg', password)

      const state = getState()
      const bcClient = createClient(state.settings.settings)

      const tx = await createUnlockTakerTx(
        txHash, txOutputIndex,
        bcAddress.toString(), bcPrivateKeyHex.toString(),
        bcClient
      )

      let data = await sendTx(state.settings.settings, tx)

      if(data.txHash){
        dispatch({
          type:SET_PENDING_TRANSACTIONS,
          payload: {hash:data.txHash,type:"Unlock Collateral",amount:'',chain:"BC"}
        });
        done(null,data);
      }
      else {
        done('Could not place order')
      }
    }
    catch(err){
      console.log({err})
      done(err)
    }
  }
}
